import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types";
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";
import SeitenKopf from "../tournamentsneu/SeitenKopf";
import LiveBereich from "../tournamentneu/LiveBereich";
import "../tournamentneu/publicTournamentNeu.css";
import "../tournamentsneu/publicTournamentsNeu.css";

/**
 * Eigenständige Live-Seite (/public/tournament/liveview, /public/eventoperator/liveview) im neuen Design:
 * Seitenkopf wie die übrigen öffentlichen Seiten, darunter der Live-Bereich mit Darstellungsauswahl, Zoom und Vollbild.
 */
function PublicLiveViewNeu({tournamentid, eventOperatorId, boardId, appCall}) {

    const [infos, setInfos] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    useEffect(() => {
        let url;
        if (vorhanden(tournamentid)) {
            url = ConfigUtil.getConfig().resourceUrls.public + "/tournament/gameinfos/available/" + tournamentid;
        } else if (vorhanden(eventOperatorId)) {
            url = ConfigUtil.getConfig().resourceUrls.public + "/eventoperator/gameinfos/available/" + eventOperatorId;
        } else {
            return;
        }
        FetchUtil.fetchGet(url,
            dto => setInfos(dto),
            responseNotOk => setErrorMessage("Fehler beim Laden der Eventinfos: " + responseNotOk.message),
            error => setErrorMessage("Fehler beim Laden der Eventinfos: " + error.message));
    }, [tournamentid, eventOperatorId]);

    useEffect(() => {
        // Hintergrund immer über den ganzen Bildschirm blau, auch beim Überscrollen (iPhone), unterhalb kurzer Inhalte
        // und neben gezoomten Inhalten; beim Verlassen der Seite wieder zurücksetzen
        const html = document.documentElement;
        const body = document.body;
        const htmlVorher = html.style.backgroundColor;
        const bodyVorher = body.style.backgroundColor;
        html.style.backgroundColor = HINTERGRUND_BLAU;
        body.style.backgroundColor = HINTERGRUND_BLAU;
        return () => {
            html.style.backgroundColor = htmlVorher;
            body.style.backgroundColor = bodyVorher;
        };
    }, []);

    const titel = infos ? (infos.tournamentBezeichnung || infos.eventOperatorBezeichnung || "Live") : "Live";

    // Brotkrumen: Veranstalter > Event > Live, soweit bekannt
    const pfad = [];
    if (infos && vorhanden(infos.eventOperatorBezeichnung) && vorhanden(infos.eventOperatorId)) {
        pfad.push({label: infos.eventOperatorBezeichnung, to: NAVIGATION_ITEM.PUBLIC_EVENTOPERATOR.route + "/" + infos.eventOperatorId});
    }
    if (infos && vorhanden(infos.tournamentBezeichnung) && vorhanden(infos.tournamentId)) {
        pfad.push({label: infos.tournamentBezeichnung, to: NAVIGATION_ITEM.PUBLIC_TOURNAMENT.route + "/" + infos.tournamentId});
    }
    pfad.push({label: "Live"});

    return <div className="dhpt-seite">
        <ErrorInfoComponent infoMessage={undefined} errorMessage={errorMessage} onClearInfoMessage={() => ""}
                            onClearErrorMessage={() => setErrorMessage(undefined)}/>
        {/* in der App kein Kopf mit Logo und Brotkrumen */}
        <SeitenKopf pfad={pfad} appCall={appCall} ohneTopbar={appCall} titel={titel}
                    chip={<span className="dhpt-chip dhpt-chip-live">Live</span>}/>
        <main className="dhpt-inhalt darthelfer-background-blue">
            {/* ohne seitlichen Einzug, damit das erste Spiel direkt am linken Rand steht */}
            <div className="dhte-bestand">
                <LiveBereich tournamentId={tournamentid} eventOperatorId={eventOperatorId} boardId={boardId} titel={titel} appCall={appCall}/>
            </div>
        </main>
    </div>
}

const HINTERGRUND_BLAU = "#022836";

function vorhanden(wert) {
    return wert !== null && wert !== undefined && wert !== "";
}

PublicLiveViewNeu.propTypes = {
    tournamentid: PropTypes.string,
    eventOperatorId: PropTypes.string,
    boardId: PropTypes.string,
    appCall: PropTypes.bool,
};

export default PublicLiveViewNeu;
